import React from 'react';
import TextField from '@material-ui/core/TextField/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import { Trans } from 'react-i18next';
import { InputAdornment } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';

export const renderTextField = ({
  id,
  name,
  label,
  classes,
  input,
  icon,
  type,
  disabled,
  autoComplete,
  helperText,
  meta: {
    touched,
    error,
  },
}) => (
  <>
    <TextField
      {...input}
      className={`${classes.formInput} ${classes.loginCredentials}`}
      type={type}
      name={name}
      label={label}
      id={id}
      variant="filled"
      disabled={disabled}
      autoComplete={autoComplete || 'off'}
      error={!['', undefined, null].includes(error)}
      helperText={helperText || ''}
      size="medium"
      InputProps={{

        endAdornment: (icon) ? (
          <InputAdornment position="end">
            <IconButton className={classes.fieldIcon} aria-label="toggle password visibility">
              {icon}
            </IconButton>
          </InputAdornment>
        ) : '',
      }}
    />
    <FormHelperText className={classes.error}>
      {error && <Trans>{touched && error}</Trans>}
    </FormHelperText>
  </>
);
